


































import { defineComponent, PropType, SetupContext } from '@vue/composition-api';

import BaseRadioGroup from '@/base/app/components/atoms/BaseRadioGroup.vue';
import BaseText from '@/base/app/components/atoms/BaseText.vue';

import { PropsTenantForm, TenantFormValue, useTenantForm } from './TenantFormComposable';

type Props = PropsTenantForm;

export default defineComponent({
  name: 'AccountTenantForm',
  components: { BaseText, BaseRadioGroup },
  model: { prop: 'value', event: 'submit' },
  props: { value: { type: Object as PropType<TenantFormValue>, required: true } },
  emits: ['submit'],
  setup(props: Props, { emit }: SetupContext) {
    return useTenantForm(props, emit);
  },
});
